import { NpsCampaignResponseDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.response.dto';
import { useQuery } from '@tanstack/react-query';
import { npsQueryKey } from 'queries/nps/queryKey';
import { NpsCampaignApi } from 'api/ApiHelper';

export const useGetNpsCampaignQuery = () =>
  useQuery<NpsCampaignResponseDto>({
    queryKey: npsQueryKey.npsCampaign,
    queryFn: () => NpsCampaignApi.getNpsCampaign(),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 60,
  });
